import App from '@/components/games/edit_game_series/App.vue'
import { createMyApp } from '@/utils/create_my_app'

// NOTE: edit_game_series.tsはturboでloadされるので、turbo:loadなどは遅すぎて使えない
(() => {
  const id = 'edit_game_series';
  const rawProps = document.getElementById(id)?.getAttribute('data');
  if(rawProps) {
    const props = JSON.parse(rawProps);
    const app = createMyApp(App, props);
    app.mount(`#${id}`);
  }
})()
